import React from 'react'

import {
    Show, TabbedShowLayout, Tab, ReferenceField, ArrayField, Datagrid,
    TextField, ImageField, FileField
} from 'react-admin'

import QRCode from 'qrcode.react'
import { QR_HOST } from '../../configs/index'

export const InterestingShow = (props) => {
    const { match: { params: { id } } } = props
    return (
        <Show {...props}>
            <TabbedShowLayout>
                <Tab label="general">
                    <ReferenceField linkType={false} label="Project name" source="project" reference="project">
                        <TextField source="name" />
                    </ReferenceField>
                    <TextField label="Interesting room name" source="name" />
                    <ImageField source="image.url" title="image.name" />
                </Tab>
                <Tab label="brochure">
                    <FileField target="_blank" style={{ marginTop: 10 }} source="brochure.url" title="brochure.name" />
                </Tab>
                <Tab label="project info">
                    <FileField target="_blank" style={{ marginTop: 10 }} source="project_info.url" title="project_info.name" />
                </Tab>

                {/* <Tab label="area info">
                    <ArrayField source="area_info">
                        <Datagrid>
                            <TextField label="Area info title" source="title" />
                            <TextField label="Area info description" source="description" />
                            <ImageField source="image.url" title="image.name" label="Area image" />
                        </Datagrid>
                    </ArrayField>
                </Tab> */}

                <Tab label="promotion">
                    <ArrayField source="promotion">
                        <Datagrid>
                            <ImageField source="image.url" label="Image" />
                            <TextField source="description" />
                        </Datagrid>
                    </ArrayField>
                </Tab>

                <Tab label="qr">
                    <div style={{ margin: '30px 0 30px 30px' }}>
                        <QRCode value={`${QR_HOST}?id=${id}`} />
                    </div>
                </Tab>

            </TabbedShowLayout>
        </Show>
    )
};


// WEBPACK FOOTER //
// ./src/components/interesting/InterestingShow.js